export const containerStyle = theme => ({
  display: 'flex',
  '&:hover, &:focus': {
    backgroundColor: theme.tokens.ComponentAccordionSummaryHoverColor
  },
  '&:focus': {
    borderStyle: 'solid',
    borderColor: theme.tokens.ComponentAccordionSummaryFocusBorder,
    borderWidth: '1px'
  },
  '&:focus-visible': {
    outline: 'none'
  }
});
export const imageStyle = theme => ({
  paddingRight: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
export const accordionChevronRightDefaultStyle = theme => ({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-180deg)',
    transitionDuration: '200ms'
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    marginRight: theme.spacing(1),
    '&.Mui-expanded': {
      margin: 0,
      marginRight: theme.spacing(1)
    }
  }
});
export const accordionChevronLeftDefaultStyle = theme => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    transitionDuration: '200ms'
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    marginLeft: theme.spacing(1),
    '&.Mui-expanded': {
      margin: 0,
      marginLeft: theme.spacing(1)
    }
  }
});
const _default = theme => ({
  paddingTop: '8px',
  paddingBottom: '8px',
  minHeight: 40,
  color: theme.tokens.ComponentAccordionSummaryColor,
  fontFamily: theme.tokens.ComponentAccordionFontName,
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '24px',
  textDecoration: 'none',
  flexGrow: 1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textWrap: 'ellipsis'
});
const _variants = (theme, contained) => ({
  ...(contained ? {
    paddingRight: '16px',
    paddingLeft: '16px'
  } : {
    paddingLeft: '4px',
    paddingRight: '4px'
  })
});
const _right = theme => ({
  ...accordionChevronRightDefaultStyle(theme)
});
const _left = theme => ({
  ...accordionChevronLeftDefaultStyle(theme)
});
export const accordionSummaryDefaultStyle = (theme, chevronPosition, contained) => {
  return {
    ..._default(theme),
    ..._variants(theme, contained),
    ...(chevronPosition === 'left' ? _left(theme) : _right(theme))
  };
};